<template>
    <div class="check-block">
        <div v-if="!isBridgePageEnabled" class="settings-row">
            <div v-for="column in blockConfiguration.columns" :key="column.id" class="settings-column">
                <ds-card v-for="(card) in column.cards" :key="card.id">
                    <ds-card-body>
                        <ds-list-item
                            v-for="(entry, entryIndex) in card.entries"
                            :key="entry.title"
                            :href="entry.link"
                            :title="entry.title"
                            :description="entry.description"
                            :border-style="borderStyle(entryIndex, card.entries.length)"
                            :as="entryAction(entry.action)"
                            clickable
                        >
                            <template #leading>
                                <ds-icon :name="entry.icon" />
                            </template>

                            <template #trailing>
                                <ds-icon name="chevron-right" />
                            </template>
                        </ds-list-item>
                    </ds-card-body>

                    <ds-card-footer>
                        <ds-text-button
                            as="a"
                            :href="card.link"
                            target="_blank"
                            trailing-icon="external-link"
                            data-qa="card-footer"
                        >
                            <div>
                                {{ card.footer }}
                            </div>
                        </ds-text-button>
                    </ds-card-footer>
                </ds-card>
            </div>
        </div>

        <div v-else class="settings-row data-clean-setting-row">
            <div
                v-for="column in checkDupsData"
                :key="column.id"
                class="settings-column-web"
            >
                <ds-card
                    v-for="(card) in column.cards"
                    :key="card.id"
                    class="data-clean-card"
                >
                    <ds-card-body>
                        <ds-list-item
                            v-for="(entry, entryIndex) in card.entries"
                            :key="entry.title"
                            :href="entry.link"
                            :title="entry.title"
                            :description="entry.description"
                            :border-style="borderStyle(entryIndex, card.entries.length)"
                            :as="entryAction(entry.action)"
                            clickable
                        >
                            <template #leading>
                                <ds-icon style="height: 4rem" :name="entry.icon" />
                            </template>

                            <template #trailing>
                                <ds-icon name="chevron-right" />
                            </template>
                        </ds-list-item>
                    </ds-card-body>
                </ds-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        blockConfiguration: Object,
        isBridgePageEnabled: Boolean,
    },

    computed: {
        checkDupsData() {
            return this.blockConfiguration.columns.filter((card) => (card.id !== 1 && card.id !== 6));
        },
    },

    methods: {
        entryAction(action) {
            return action === 'link' ? 'a' : 'div';
        },

        borderStyle(entryIndex, entryLength) {
            return entryIndex === (entryLength - 1) ? 'none' : 'full';
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

    .list-item > .leading-slot {
        min-width: px-to-rem(40px);
        padding: px-to-rem(14px) 0 0 0;
    }

    .list-item-info > .trailing-slot {
        margin: 0;
        padding-top: 14px;
        --icon-color: rgba(0, 0, 0, 0.29);
    }

    :deep(.settings-column-web .item-text > .title) {
      padding: 3px 0;
      color: rgba(0, 0, 0, 0.82);
      font-weight: normal;
      white-space: initial;
      line-height: 1.5;
    }

    :deep(.settings-column-web .item-text > .description) {
      -webkit-line-clamp: 3;
      color: rgba(0, 0, 0, 0.6);
      display: block;
    }

    .check-block {
        margin: 0;
    }

    .settings-row {
        display: flex;
        flex-wrap: wrap;
    }

    .settings-column {
        flex: 33%;
        padding: $spacing-050;
    }

    .settings-column-web {
        display: flex;
        flex: $spacing-100;
        padding: 0;
    }

    .ds-card {
        width: 19.5rem;
        height: fit-content;
        margin-bottom: $spacing-400;
    }

    .ds-card-footer {
        text-align: center;
    }

    .ds-card-body {
        padding: 0;
    }

    .ds-card-body .list-item {
        padding: $spacing-200;
    }

    .data-clean-setting-row {
      margin-right: px-to-rem(153px);
    }

    .data-clean-card {
      width: 20rem;
    }
</style>
